export default __webpack_public_path__ + "static/media/slope.c97b5b09.svg";